import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare, faSquareCheck } from '@fortawesome/free-regular-svg-icons';
export const CrosswordForm = ({ crossword: crosswordData, onSubmit, onCancel, }) => {
    const [validationMessage, setValidationMessage] = useState('');
    const [crossword, setCrossword] = useState(crosswordData || {
        name: '',
        duration: '600',
        settings: {
            randomiseGrid: false,
            sendResultEmail: false,
            public: false,
            timed: false,
        },
    });
    const handleNameChange = (e) => {
        if (e.target.value.length <= 35) {
            setCrossword({
                ...crossword,
                name: e.target.value,
            });
        }
        else {
            e.target.value = e.target.value.slice(0, 35);
        }
    };
    const handleDurationChange = (e) => {
        setCrossword({
            ...crossword,
            duration: e.target.value,
        });
    };
    const handleTimedSettingChange = () => {
        setCrossword({
            ...crossword,
            duration: '600',
            settings: {
                ...crossword.settings,
                timed: !crossword.settings.timed,
            },
        });
    };
    const handleRandomiseGridSettingChange = () => {
        setCrossword({
            ...crossword,
            settings: {
                ...crossword.settings,
                randomiseGrid: !crossword.settings.randomiseGrid,
            },
        });
    };
    const handlePublicSettingChange = () => {
        setCrossword({
            ...crossword,
            settings: {
                ...crossword.settings,
                public: !crossword.settings.public,
            },
        });
    };
    const handleSendResultEmailSettingChange = () => {
        setCrossword({
            ...crossword,
            settings: {
                ...crossword.settings,
                sendResultEmail: !crossword.settings.sendResultEmail,
            },
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (crossword.name === '') {
            setValidationMessage('Crossword Name cannot be empty');
        }
        else {
            onSubmit(crossword);
        }
    };
    return (React.createElement("form", { className: "form", onSubmit: handleSubmit },
        React.createElement("div", { className: "form__control" },
            React.createElement("div", { className: "input-group" },
                React.createElement("input", { type: "text", name: "name", placeholder: "", defaultValue: crossword.name, onChange: handleNameChange, onFocus: () => {
                        setValidationMessage('');
                    } }),
                React.createElement("label", null, "Crowssword Name"),
                React.createElement("span", { className: "character-count" },
                    crossword.name ? crossword.name.length : 0,
                    " / 35")),
            React.createElement("div", { className: "options-group" },
                React.createElement("div", null,
                    React.createElement(FontAwesomeIcon, { id: "A", icon: crossword.settings.timed === true ? faSquareCheck : faSquare, className: "faCheckBox", onClick: handleTimedSettingChange }),
                    React.createElement("label", null, "Timed")),
                React.createElement("div", null,
                    React.createElement(FontAwesomeIcon, { id: "A", icon: crossword.settings.randomiseGrid === true
                            ? faSquareCheck
                            : faSquare, className: "faCheckBox", onClick: handleRandomiseGridSettingChange }),
                    React.createElement("label", null, "Randomise Grid")),
                React.createElement("div", null,
                    React.createElement(FontAwesomeIcon, { id: "A", icon: crossword.settings.sendResultEmail === true
                            ? faSquareCheck
                            : faSquare, className: "faCheckBox", onClick: handleSendResultEmailSettingChange }),
                    React.createElement("label", null, "Send Result Email")),
                React.createElement("div", null,
                    React.createElement(FontAwesomeIcon, { id: "A", icon: crossword.settings.public === true ? faSquareCheck : faSquare, className: "faCheckBox", onClick: handlePublicSettingChange }),
                    React.createElement("label", null, "Share Publicly"))),
            crossword.settings.timed && (React.createElement("div", { className: "range-group" },
                React.createElement("span", { className: "duration-label" },
                    "Duration:",
                    ' ',
                    crossword.duration
                        ? parseInt(crossword.duration) < 600
                            ? `0${parseInt(crossword.duration) / 60}`
                            : parseInt(crossword.duration) / 60
                        : 0,
                    ' ',
                    "min"),
                React.createElement("input", { type: "range", min: '300', max: '3600', step: 300, defaultValue: crossword.duration, onChange: handleDurationChange })))),
        React.createElement("div", { className: "form-actions" },
            React.createElement("button", { className: "btn--primary", type: "submit" }, crosswordData ? 'Update' : 'Create'),
            React.createElement("button", { type: "button", className: "btn--secondary", onClick: onCancel }, "Cancel")),
        React.createElement("p", { className: "validation-message" }, validationMessage)));
};
